
import notifications from "../../lib/notifications";
import { Vue, Prop, Component } from "vue-property-decorator";
import { getModule } from "vuex-module-decorators";
import { OrderModule, SystemModule } from "@/store/modules";

const orderModule = getModule(OrderModule);
const systemModule = getModule(SystemModule);

interface DefaultReference {
  id: null;
  type: null;
  number: null;
  typeDescription: null;
  displayType: null;
}

@Component
export default class OrderReferenceNumbers extends Vue {
  newReferenceNumber: DefaultReference = {
    id: null,
    type: null,
    number: null,
    typeDescription: null,
    displayType: null
  };
  currentEditRefNum: any = { id: null, type: null, number: null, displayType: null };

  @Prop({ default: false })
  loading: boolean;

  get newReferenceNumberDescription() {
    const result = systemModule.referenceTypes.find(x => x.id === this.newReferenceNumber.type);
    return result ? result.name : null;
  }

  get newReferenceNumberDisplayId() {
    const result = systemModule.referenceTypes.find(x => x.id === this.newReferenceNumber.type);
    return result ? result.displayId : null;
  }

  get referenceNumbers() {
    return orderModule.currentOrderReferenceNumbers;
  }

  set referenceNumbers(newVal) {
    this.referenceNumbers = newVal;
  }

  get referenceTypes() {
    return systemModule.referenceTypes;
  }

  cancelUpdate() {
    this.currentEditRefNum = { id: null, number: null, type: null };
  }

  editReference(ref) {
    this.currentEditRefNum = {
      id: ref.id,
      number: ref.number,
      type: ref.type,
      displayType: ref.displayType
    };
  }

  isEditing(number) {
    return this.currentEditRefNum.id === number.id ? true : false;
  }

  updateReference() {
    orderModule
      .updateReferenceNumberForCurrentOrder(this.currentEditRefNum)
      .then(response => {
        this.cancelUpdate();
      })
      .catch(ex => {
        notifications.error("Update Reference Failed", "Failed to update reference number", ex);
      });
  }

  deleteReference(referenceNumber) {
    this.$bvModal
      .msgBoxConfirm(
        `Are you sure you want to remove the reference number '${referenceNumber.displayType}'?`
      )
      .then(confirmed => {
        if (confirmed) {
          orderModule
            .deleteReferenceNumberFromCurrentOrder(referenceNumber.id)
            .then(response => {
              notifications.success(
                "Reference Number Removed",
                "Reference number successfully removed."
              );
            })
            .catch(() =>
              notifications.error(
                "Reference Number Removal Failed",
                "Failed to remove reference number"
              )
            );
        }
      });
  }

  addReferenceNumber() {
    orderModule
      .addReferenceNumberToCurrentOrder(this.newReferenceNumber)
      .then(result => {
        this.resetReferenceNumber();
      })
      .catch(ex => {
        notifications.error("Add Reference Failed", "Failed to add reference number", ex);
      });
  }

  resetReferenceNumber() {
    this.newReferenceNumber = { id: null, type: null, number: null, typeDescription: null, displayType: null };
  }
}
